import React, { memo, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getChangeMusicLayoutModeAction,
  getChangeMusicSortModeAction,
  getChangeMusicTemporalIntervalAction,
} from "../../store/actionCreators";
import {
  MusicsDtpFilterBarDivider,
  MusicsDtpFilterBarLeftWrapper,
  MusicsDtpFilterBarRightWrapper,
  MusicsDtpFilterBarWrapper,
  MusicsDtpFilterDropdownTitle,
  MusicsDtpFilterDropdownWrapper,
} from "./style";
import {
  musicFilterDateIntervals,
  musicsAllEventsSortModes,
} from "../../local-data";
import { Dropdown } from "antd";
import {
  LAYOUT_MODE_CARD,
  LAYOUT_MODE_LIST,
} from "../../../../common/constants";
import classNames from "classnames";
import { ReactComponent as CardLayoutIcon } from "@/assets/img/icons/icon-layout-card.svg";
import { ReactComponent as ListLayoutIcon } from "@/assets/img/icons/icon-layout-list.svg";
import KTHomeDesktopFilterButton from "../../../home/c-pages/all-events/c-components/home-desktop-filter-bar/c-components/home-desktop-filter-button";
import KTSwitchCityDtpDropdown from "../../../../components/dropdown/switch-city-dtp-dropdown";
import KTSwitchCustomTimeIntervalDropdown from "../../../../components/dropdown/switch-custom-time-interval-dropdown";
import { getGlobalDateString } from "../../../../utils/tool-time-intervcal";

const KTMusicsDtpFiterBar = memo(() => {
  const dispatch = useDispatch();

  const [customTimeIntervalOpen, setCustomTimeIntervalOpen] = useState(false);

  const { sortMode, layoutMode, intervalType, startdt, enddt, city } =
    useSelector(
      (state) => ({
        sortMode: state.getIn(["musics", "sortMode"]),
        layoutMode: state.getIn(["musics", "layoutMode"]),
        categories: state.getIn(["musics", "categories"]),
        intervalType: state.getIn(["musics", "intervalType"]),
        startdt: state.getIn(["musics", "startdt"]),
        enddt: state.getIn(["musics", "enddt"]),
        city: state.getIn(["global", "city"]),
      }),
      shallowEqual
    );

  let cityMessage = "Any Location";

  if (typeof city === "object" && Object.keys(city).length > 0) {
    const name = city.name ?? city.city ?? "";
    const state = city.state ?? "";
    if (name.length === 0 || state.length === 0) {
      cityMessage = `${name}${city.state}`;
    } else {
      cityMessage = `${name}, ${city.state}`;
    }
  }

  const onclickChangeLayoutMode = (mode) => {
    dispatch(getChangeMusicLayoutModeAction(mode));
  };

  const dateMessage = getGlobalDateString(
    musicFilterDateIntervals,
    intervalType,
    startdt,
    enddt
  );

  function dropdownRender(menu) {
    return (
      <MusicsDtpFilterDropdownWrapper>
        {React.cloneElement(menu, {
          style: { boxShadow: "none" },
        })}
      </MusicsDtpFilterDropdownWrapper>
    );
  }

  // sort
  const sortItems = musicsAllEventsSortModes
    .map((ele, index) => {
      const resultArr = [
        {
          label: (
            <MusicsDtpFilterDropdownTitle>
              {ele.title}
            </MusicsDtpFilterDropdownTitle>
          ),
          key: index,
        },
      ];

      resultArr.push({
        type: "divider",
        style: { margin: "0 0" },
      });

      return resultArr;
    })
    .flat();

  const onSortModeClick = ({ key }) => {
    const sortMode = musicsAllEventsSortModes[key];
    dispatch(getChangeMusicSortModeAction(sortMode));
  };

  // date range

  const dateRangeItems = musicFilterDateIntervals
    .map((ele, index) => {
      const resultArr = [
        {
          label: (
            <MusicsDtpFilterDropdownTitle>
              {ele.title}
            </MusicsDtpFilterDropdownTitle>
          ),
          key: index,
        },
      ];

      resultArr.push({
        type: "divider",
        style: { margin: "0 0" },
      });

      return resultArr;
    })
    .flat();

  const onDateRangeClick = ({ key }) => {
    const dateRange = musicFilterDateIntervals[key];
    dispatch(getChangeMusicTemporalIntervalAction(dateRange.value));
    if (key === "6") {
      setCustomTimeIntervalOpen(true);
    }
  };

  return (
    <MusicsDtpFilterBarWrapper>
      <MusicsDtpFilterBarLeftWrapper>
        <Dropdown
          autoAdjustOverflow={false}
          menu={{ items: sortItems, onClick: onSortModeClick }}
          trigger={["click"]}
          dropdownRender={dropdownRender}
        >
          <KTHomeDesktopFilterButton
            title={sortMode.title}
            styled={1}
            onClick={(e) => e.preventDefault()}
          />
        </Dropdown>

        <MusicsDtpFilterBarDivider />

        <KTSwitchCityDtpDropdown>
          <KTHomeDesktopFilterButton
            title={cityMessage}
            onClick={(e) => e.preventDefault()}
          />
        </KTSwitchCityDtpDropdown>

        <KTSwitchCustomTimeIntervalDropdown
          open={customTimeIntervalOpen}
          onCancelClick={() => {
            setCustomTimeIntervalOpen(false);
          }}
          startdt={startdt}
          enddt={enddt}
          didIntervalValueChange={(ele) => {
            dispatch(
              getChangeMusicTemporalIntervalAction("6", ele.startdt, ele.enddt)
            );
          }}
        >
          <Dropdown
            autoAdjustOverflow={false}
            menu={{ items: dateRangeItems, onClick: onDateRangeClick }}
            trigger={["click"]}
            dropdownRender={dropdownRender}
          >
            <KTHomeDesktopFilterButton
              title={dateMessage}
              onClick={(e) => e.preventDefault()}
            />
          </Dropdown>
        </KTSwitchCustomTimeIntervalDropdown>
      </MusicsDtpFilterBarLeftWrapper>
      <MusicsDtpFilterBarRightWrapper>
        <CardLayoutIcon
          className={classNames("layoutModel", {
            activeLayoutModel: layoutMode === LAYOUT_MODE_CARD,
          })}
          onClick={() => onclickChangeLayoutMode(LAYOUT_MODE_CARD)}
        />
        <ListLayoutIcon
          className={classNames("layoutModel", {
            activeLayoutModel: layoutMode === LAYOUT_MODE_LIST,
          })}
          onClick={() => onclickChangeLayoutMode(LAYOUT_MODE_LIST)}
        />
      </MusicsDtpFilterBarRightWrapper>
    </MusicsDtpFilterBarWrapper>
  );
});

export default KTMusicsDtpFiterBar;
